import { render, staticRenderFns } from "./note.html?vue&type=template&id=4d637a7b&scoped=true&"
import script from "./note.js?vue&type=script&lang=js&"
export * from "./note.js?vue&type=script&lang=js&"
import style0 from "./note.scss?vue&type=style&index=0&id=4d637a7b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d637a7b",
  null
  
)

export default component.exports